/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />

namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable()
    export class ProductdealsDialog extends Serenity.Extensions.GridEditorDialog<ProductdealsRow> {
        protected getFormKey() { return ProductdealsForm.formKey; }
        protected getLocalTextPrefix() { return ProductdealsRow.localTextPrefix; }

        protected form: ProductdealsForm;
        constructor() {
            super();

            this.form = new ProductdealsForm(this.idPrefix);
        }
        protected updateInterface() {
            super.updateInterface();
            var $form = this.form;
            var $this = this;

            $form.PdtId.getGridField().on('change', function () {
                if ($form.PdtId.value) {
                    ProductsService.Retrieve({
                        EntityId: $form.PdtId.value
                    }, (res) => {

                        var pdt = res.Entity;
                        Serenity.EditorUtils.setValue($form.PdtIdNm, pdt.ProductName);
                        Serenity.EditorUtils.setValue($form.Currencies, pdt.Currencies);
                        Serenity.EditorUtils.setValue($form.PdtPrc, pdt.PriceList);
                        Serenity.EditorUtils.setValue($form.PdtQty, pdt.Quantity);
                        Serenity.EditorUtils.setValue($form.PdtDisc, pdt.Discount);
                        Serenity.EditorUtils.setValue($form.PdtTotal, pdt.TotalPrice);
                        Serenity.EditorUtils.setValue($form.PdtImg, pdt.Image);
                        Serenity.EditorUtils.setValue($form.PdtDesc, pdt.ProductDesc);
                        Serenity.EditorUtils.setValue($form.UnitIds, pdt.UnitIds);
                        Serenity.EditorUtils.setValue($form.PdtCd, pdt.ProductCode);
                    });
                }
            })
            this.form.PdtDisc.getGridField().find('input').on('keyup', function () {
                if ($form.PdtDisc.value > 100) {
                    Serenity.EditorUtils.setValue($form.PdtDisc, 100);
                }
                $this.doCalculation();
            });
            this.form.PdtPrc.getGridField().find('input').on('keyup', function () {
                $this.doCalculation();
            });
            this.form.PdtQty.getGridField().find('input').on('keyup', function () {
                //if ($form.PdtQty.value == null || $form.PdtQty.value == 0) {
                //    Serenity.EditorUtils.setValue($form.PdtQty, 1);
                //}
                $this.doCalculation();
            });
            if (Q.isEmptyOrNull(this.get_entity().Currencies)) {
                this.form.Currencies.value = $.cookie('currencies') == undefined ? "Rp" : $.cookie('currencies');
            }
        }
        private doCalculation() {
            var $this = this;
            var $form = this.form;
            var diskon = this.form.PdtDisc.value / 100;
            var totawal = this.form.PdtPrc.value * this.form.PdtQty.value;
            var hardikon = totawal * diskon;
            this.form.PdtTotal.value = totawal - hardikon;
            var list = this.form.Currencies.value + this.form.PdtTotal.value.toString;
        }
    }
}